export default {
  primary: '#22C044',
  accent: '#F07C20',
  info: '#2D9CDB',
  white: '#FFFFFF',
  greyDeep: '#555555',
  greyFaint2: '#F5F5F5',
  greyLight1: '#C9C9C9',
  greyLight2: '#D5D5D5',
  greyLight3: '#E0E0E0',
  greyLight4: '#EFEFEF',
  neutralBlue: '#006CEA',
  neutralRed: '#EF5858',
  neutralYellow: '#F2994A',
  neutralGreen: '#5FC963',
};
